import { InfoItem } from 'components/molecules/InfoItem/InfoItem';
import { InterviewStageFragment } from 'generated/graphql';
import {
  getInterviewStageDurationLabel,
  getInterviewStageFocusLabel,
} from 'views/Project/components/Stages/helpers';
import {
  SoftSkill,
  sortSoftSkillsByCategory,
} from 'views/Project/components/Stages/InterviewStageOverview/InterviewStageOverview.helpers';
import { getStageDate } from 'views/Project/components/Stages/StageOverview/StageOverview.helpers';
import { Tag, TagColor, TagSize } from '@spotted-zebra-uk/ui-components';
import styles from './InterviewStageOverview.module.scss';

const InterviewStageOverview = ({
  interviewStage,
}: {
  interviewStage: InterviewStageFragment;
}) => {
  const sortedSoftSkills = sortSoftSkillsByCategory(interviewStage.softSkills);

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>General</h3>
      <div className={styles.row}>
        <InfoItem label="Name" value={interviewStage.name} />
        <InfoItem
          label="Interview duration"
          value={getInterviewStageDurationLabel(interviewStage.duration)}
        />
        <InfoItem
          label="Interview focus"
          value={getInterviewStageFocusLabel(interviewStage.focus)}
        />
        <InfoItem label="SubId" value={interviewStage.subId} />
        <InfoItem
          label="Date created"
          value={getStageDate(interviewStage.createdAt)}
        />
      </div>

      <h3 className={styles.title}>Priority skills</h3>
      <div className={styles.categoriesContainer}>
        <h4 className={styles.categoryTitle}>Right for the role</h4>
        <p className={styles.categorySubtitle}>Soft skills</p>
        <InterviewStageSkillsList
          skills={sortedSoftSkills.rightForRole}
          label="soft skills"
        />
        <p className={styles.categorySubtitle}>Technical skills</p>
        <InterviewStageSkillsList
          skills={interviewStage.technicalSkills as SoftSkill[]}
          label="technical skills"
        />
        <h4 className={styles.categoryTitle}>Right for us</h4>
        <InterviewStageSkillsList
          skills={sortedSoftSkills.rightForUs}
          label="values"
        />
        <h4 className={styles.categoryTitle}>Right for the future</h4>
        <InterviewStageSkillsList
          skills={sortedSoftSkills.rightForFuture}
          label="indicators of potential"
        />
      </div>
    </div>
  );
};

export default InterviewStageOverview;

const InterviewStageSkillsList = ({
  skills,
  label,
}: {
  skills: SoftSkill[];
  label: string;
}) => {
  if (skills.length === 0) {
    return (
      <p
        className={styles.noSkills}
      >{`The interview stage doesn't include any ${label}.`}</p>
    );
  }
  return (
    <div className={styles.skillsList}>
      {skills.map(skill => (
        <Tag
          key={skill.id}
          isPresentational
          isDismissible={false}
          tagColor={TagColor.BLUE}
          size={TagSize.SMALL}
          ariaLabel={skill.name}
        >
          {skill.name}
        </Tag>
      ))}
    </div>
  );
};
